import { FunctionComponent } from 'react'
import styled from 'styled-components'

import * as PT from 'modules/Pricing/types'

import { addCommas } from 'utils/stringFormatting'

import * as T from 'types'
import * as E from 'types/enums'

interface IContainerProps {
  disabled?: boolean
}
const Container = styled.div<IContainerProps>`
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`

interface ITitlePropsArg extends PT.IPricingPackageCardModeProps {
  theme: any
}
const getTextColor = (props: ITitlePropsArg, defaultColor: string) => {
  if (props.mode === E.PackageCardMode.ComingSoon) return props.theme.colors.grey34

  if (props.mode === E.PackageCardMode.Best) return props.theme.colors.white

  return defaultColor
}

const PriceNowText = styled.div<PT.IPricingPackageCardModeProps>`
  font-weight: 900;
  font-size: 24px;
  line-height: 33px;
  color: ${props => getTextColor(props, props.theme.colors.neutral800)};
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-size: 32px;
    line-height: 44px;
  }
`

const NowText = styled.span`
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
`

const PriceAtClosingText = styled.div<PT.IPricingPackageCardModeProps>`
  font-weight: 900;
  font-size: 16px;
  line-height: 22px;
  color: ${props => getTextColor(props, props.theme.colors.neutral800)};

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
`

const TBDText = styled.div`
  font-weight: 900;
  font-size: 24px;
  line-height: 33px;
  color: ${props => props.theme.colors.neutral300};

  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    font-weight: 900;
    font-size: 32px;
    line-height: 44px;
  }
`

const TotalPriceComma = styled.span`
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    display: none;
  }
`

const TotalPriceText = styled.div`
  display: inline;
  @media (min-width: ${props => props.theme.metrics.desktop}px) {
    display: block;
  }
`

interface IProps extends Partial<PT.IPricingPackageCardModeProps> {
  pricingPackage: T.IPricingPackage | undefined
}

const PriceBox: FunctionComponent<IProps> = ({ mode, pricingPackage }) => {
  if (!pricingPackage) return null

  return (
    <Container>
      {mode !== E.PackageCardMode.ComingSoon
        ? (
          <>
            {!pricingPackage.payNow && <PriceNowText mode={mode}>Free to List</PriceNowText>}
            {!!pricingPackage.payNow && (
              <PriceNowText mode={mode}>
                {`$${addCommas(pricingPackage.payNow)}`} <NowText>Now</NowText>
              </PriceNowText>
            )}
            <PriceAtClosingText mode={mode}>
              <span>{`$${addCommas(pricingPackage.payAtClose)} at Closing`}</span>
              {!!pricingPackage?.payNow && (
                <TotalPriceText>
                  <TotalPriceComma>, </TotalPriceComma>
                  {`$${addCommas(pricingPackage.payNow + pricingPackage.payAtClose)} Total`}
                </TotalPriceText>
              )}
            </PriceAtClosingText>
          </>
        )
        : (
          <TBDText>TBD</TBDText>
        )}
    </Container>
  )
}

export default PriceBox
